const isProd = process.env.NODE_ENV === 'production'

function setCustomEntryUrl(entryUrl, appName) {
  // 开发调试时切换的微应用的页面入口地址
  const customEntryUrl = 'http://localhost:8080'
  // 需要自定义页面入口地址的应用，未设置则统一配置
  const app = {
    // key：应用名称(查看控制台接口返回值），val：页面入口地址
    // 'example-app-dev-test': 'http://localhost:8080'
    // 或者，直接返回接口的入口地址
    // [appName]: entryUrl
    'cherrug-app': 'http://localhost:8131',
    sitirtree: 'http://localhost:8081',
    kaki: 'http://localhost:9080',
    'sitirtree-app': 'http://localhost:8083',
    bubalus: 'http://localhost:8081',
    chipmunk: 'http://localhost:8080',
    cems: 'http://localhost:8080',
  }

  return app[appName] ? app[appName] || customEntryUrl || entryUrl : entryUrl
}

export default function setEntryUrl(entryUrl, appName) {
  const customEntryUrl = setCustomEntryUrl(entryUrl, appName)
  if (!isProd) {
    return customEntryUrl
  }
  return entryUrl
}
